import { type Dayjs } from "dayjs";
import axiosService from "../../services/axios-util/axios-services";

/* 統計情報 */

const getStatisticsSummaryTotal = async (date: Dayjs) => {
  const params = {
    date: date.format("YYYY-MM-DD")
  }
  const response = await axiosService.get(`mng/statistics/summary/total`, {params});
  return response.data;
}

const getStatisticsSummaryTerm = async (startDate: Dayjs, endDate: Dayjs) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  }
  const response = await axiosService.get(`mng/statistics/summary/term`, {params});
  return response.data;
}

const getStatisticsUserUtilizationTotalling = async (startDate: Dayjs, endDate: Dayjs) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  }
  const response = await axiosService.get(`mng/statistics/users/utilization/totalling`, {params});
  return response.data;
}

const getStatisticsUserUtilizationTags = async (startDate: Dayjs, endDate: Dayjs, limit: number) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
    limit: limit,
  }
  const response = await axiosService.get(`mng/statistics/users/utilization/tags`, {params});
  return response.data;
}

/* 管理ユーザー */

const getAdminUsers = async (page: number) => {
  const params = {page: page}
  const response = await axiosService.get(`mng/admin_users`, {params});
  return response.data;
};

const createAdminUser = async (params: any) => {
  const body = {
    admin_user: { ...params }
  };
  const response = await axiosService.post(`mng/admin_users`, body);
  return response;
};

const updateAdminUser = async (id: number, params: any) => {
  const body = {
    admin_user: { ...params }
  };
  const response = await axiosService.put(`mng/admin_users/${id}`, body);
  return response;
};

const deleteAdminUser = async (id: number) => {
  const response = await axiosService.delete(`mng/admin_users/${id}`);

  return response;
};

/* ユーザーへの通知 */

const getUserNotifications = async (params: any) => {
  const response = await axiosService.get(`mng/user_notifications`, {params});
  return response.data;
}

const sendUserNotification = async (body: any) => {
  const response = await axiosService.post(`mng/notifications/send`, body);
  return response;
}

/* メンバーグループ */

const getMemberGroupList = async (params: any) => {
  const response = await axiosService.get(`mng/member_groups`, {params});
  return response.data;
}

const getMemberGroup = async (id: number) => {
  const response = await axiosService.get(`mng/member_groups/${id}`);
  return response.data;
}

const getMemberGroupUsers = async (id: number) => {
  const response = await axiosService.get(`mng/member_groups/${id}/member_group_users`);
  return response.data;
}

const getMemberGroupBanner = async (id: number): Promise<Blob> => {
  const res = await axiosService.get(`mng/member_groups/${id}/banner`, {
    responseType: 'blob'
  });
  return res.data;
};

const getMemberGroupIcon = async (groupId: number): Promise<Blob> => {
  const res = await axiosService.get(`mng/member_groups/${groupId}/icon`, {
    responseType: 'blob'
  });
  return res.data;
};

/* ジャンル */

const getGroups = async (page: number) => {
  const params = {page: page}
  const response = await axiosService.get(`mng/groups`, {params});
  return response.data;
};

const createGroup = async (name: string) => {
  const body = {
    group: { name: name },
  };
  const response = await axiosService.post(`mng/groups`, body);

  return response;
};

const updateGroup = async (name: string, id: number) => {
  const body = {
    group: { name: name },
  };

  const response = await axiosService.put(`mng/groups/${id}`, body);

  return response;
};

const deleteGroup = async (id: number) => {
  const response = await axiosService.delete(`mng/groups/${id}`);

  return response;
};

const getAllGroups = async () => {
  const response = await axiosService.get(`mng/groups/all_groups`);
  return response.data;
};

/* NGワード */

const getNegativeWords = async () => {
  const response = await axiosService.get(`mng/negative_words/all`);
  return response.data;
}

const createNegativeWord = async (params: any) => {
  const body = {
    negative_word: params
  }
  const response = await axiosService.post(`mng/negative_words`, body);
  return response;
}

const deleteNegativeWord = async (id: number) => {
  const response = await axiosService.delete(`mng/negative_words/${id}`);
  return response;
}

const getPagyNegativeWordList = async (params: any) => {
  const response = await axiosService.get(`mng/negative_words`, {params});
  return response.data;
}

/* 投稿 */
const getPendingPosts = async (params: any) => {
  const response = await axiosService.get(`mng/posts/pending_posts`, {params});
  return response.data;
};

const getPendingPostsCount = async () => {
  const response = await axiosService.get(`mng/posts/pending_posts_count`);
  return response.data;
};

const getPost = async (postId: number) => {
  const response = await axiosService.get(`mng/posts/${postId}`);
  return response.data;
};

const getPostSlimData = async (postId: number) => {
  const response = await axiosService.get(`mng/posts/${postId}/slim`);
  return response.data;
};

const createPost = async (body: any) => {
  const response = await axiosService.post(`mng/posts`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response;
};

const editPost = async (id: number, body: any) => {
  const response = await axiosService.put(`mng/posts/${id}`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

const approvePost = async (post_id: number) => {
  const response = await axiosService.patch(`mng/posts/${post_id}/approve`);

  return response;
};

const rejectPost = async (post_id: number) => {
  const response = await axiosService.patch(`mng/posts/${post_id}/reject`);

  return response;
};

const getPostCommnets = async (postId: number, statuses?: string[]) => {
  const params = {statuses: statuses}
  const response = await axiosService.get(`mng/posts/${postId}/comments`, {params});
  return response.data;
};

const getPostImage = async (postId: number, id: number): Promise<Blob> => {
  const res = await axiosService.get(`mng/posts/${postId}/images/${id}`, {
    responseType: 'blob'
  });
  return res.data;
};

const getAttachment = async (postId: number, id: number): Promise<Blob> => {
  const res = await axiosService.get(`mng/posts/${postId}/attachments/${id}`, {
    responseType: 'blob'
  });
  return res.data;
};

const getOpinionPosts = async (params: any) => {
  const response = await axiosService.get(`mng/posts/opinion_posts`, {params});
  return response.data;
};

const getEveryonePosts = async (params: any) => {
  const response = await axiosService.get(`mng/posts/everyone_posts`, {params});
  return response.data;
};

const getEventPosts = async (params: any) => {
  const response = await axiosService.get(`mng/posts/event_posts`, {params});
  return response.data;
};

const getEventPost = async (postId: number) => {
  const response = await axiosService.get(`mng/posts/${postId}/event_post`);
  return response.data;
};

const getEventPostUsers = async (postId: number) => {
  const response = await axiosService.get(`mng/posts/${postId}/event_post/users`);
  return response.data;
}

const getVoteOptions = async (postId: number) => {
  const response = await axiosService.get(`mng/posts/${postId}/vote_options`);
  return response.data;
}

const getRejectedPosts = async (params: any) => {
  const response = await axiosService.get(`mng/posts/rejected_posts`, {params})
  return response.data
}

/* 投稿の報告理由 */

const getPostReports = async (id: number) => {
  const response = await axiosService.get(`mng/posts/${id}/post_reports`)
  return response.data
}

/* プライベート投稿を見られるユーザー */

const addUserInPost = async (postId: number, userId: number, privaterType: string) => {
  const res = await axiosService.post(`mng/post_private_users`, {
    post_private_user: {
      post_id: postId,
      privater_id: userId,
      privater_type: privaterType,
    }
  });
  return res.data;
};

const removeUserInPost = async (userId: number) => {
  const res = await axiosService.delete(`mng/post_private_users/${userId}`);
  return res.data;
};

/* コメント */

const getComments = async (params: any) => {
  const response = await axiosService.get(`mng/comments`, {params});
  return response.data;
};

const getCommentImage = async (comment_id: number, id: number): Promise<Blob> => {
  const res = await axiosService.get(`mng/comments/${comment_id}/images/${id}`, {
    responseType: 'blob'
  });
  return res.data;
};

const approveComment = async (comment_id: any) => {
  const response = await axiosService.patch(`mng/comments/${comment_id}/approve`);

  return response;
};

const rejectComment = async (comment_id: any) => {
  const response = await axiosService.patch(`mng/comments/${comment_id}/reject`);

  return response;
};

/* サンプル画像の管理 */

const createSampleImage = async (file: File) => {
  let body = {
    file: file,
  };
  const response = await axiosService.post(`mng/sample_images`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response;
};

const updateSampleImage = async (id: number, file: File) => {
  let body = {
    file: file,
  };

  const response = await axiosService.put(`mng/sample_images/${id}`, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response;
};

const deleteSampleImage = async (id: number) => {
  await axiosService.delete(`mng/sample_images/${id}`);
};

/* 意見 */

const getSuggestions = async (page: any) => {
  const params = {page: page}
  const response = await axiosService.get(`mng/suggestions`, {params});
  return response.data;
};

const getSuggestion = async (suggestionId: number) => {
  const response = await axiosService.get(`mng/suggestions/${suggestionId}`);
  return response.data;
};

/* めぶくPay取引管理 */

const getPayments = async (params: any) => {
  const response = await axiosService.get(`mng/payments`, {params});
  return response.data;
};

/* 画像 */

const getSampleImageList = async (params?: any) => {
  const response = await axiosService.get(`mng/sample_images`, params ? {params} : {});
  return response.data
};

const getSampleImage = async (id: number): Promise<File> => {
  const response = await axiosService.get(`mng/sample_images/${id}/file`, {
    responseType: 'blob'
  });

  const disposition = response.headers['content-disposition'];
  let filename = id.toString();
  if (disposition && disposition.includes('filename=')) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) {
      filename = match[1];
    }
  }
  return new File([response.data], filename, { type: response.data.type });
};

/* 検索 */

const searchUsers = async (term: any, cancelToken: any, includeNavigator: boolean = false) => {
  const params = {
    term: term,
    include_navigator: includeNavigator
  }
  const response = await axiosService.get(`mng/search_users`, {params, cancelToken: cancelToken});
  return response.data;
};

/* カテゴリー */

const getCategories = async () => {
  const response = await axiosService.get(`mng/categories`);
  return response.data
};

/* 報告 */

const createPostReport = async (postId: number, reason: string) => {
  const body = {
    post_id: postId,
    reason: reason
  }
  const response = await axiosService.post(`mng/post_reports`, body);
  return response
};

const getMyPostReportList = async () => {
  const response = await axiosService.get(`mng/post_reports/my_reports`);
  return response.data
};

const apiServices = {
  getStatisticsSummaryTotal,
  getStatisticsSummaryTerm,
  getStatisticsUserUtilizationTotalling,
  getStatisticsUserUtilizationTags,
  getAdminUsers,
  createAdminUser,
  updateAdminUser,
  deleteAdminUser,
  getUserNotifications,
  sendUserNotification,
  getMemberGroupList,
  getMemberGroup,
  getMemberGroupUsers,
  getMemberGroupBanner,
  getMemberGroupIcon,
  getGroups,
  createGroup,
  updateGroup,
  deleteGroup,
  getAllGroups,
  getNegativeWords,
  createNegativeWord,
  deleteNegativeWord,
  getPagyNegativeWordList,
  getPendingPosts,
  getPendingPostsCount,
  getPost,
  getPostSlimData,
  createPost,
  editPost,
  approvePost,
  rejectPost,
  getPostCommnets,
  getPostImage,
  getAttachment,
  getOpinionPosts,
  getEveryonePosts,
  getEventPosts,
  getEventPost,
  getEventPostUsers,
  getVoteOptions,
  getRejectedPosts,
  getPostReports,
  addUserInPost,
  removeUserInPost,
  getComments,
  getCommentImage,
  approveComment,
  rejectComment,
  createSampleImage,
  updateSampleImage,
  deleteSampleImage,
  getSuggestions,
  getSuggestion,
  getPayments,
  getSampleImageList,
  getSampleImage,
  searchUsers,
  getCategories,
  createPostReport,
  getMyPostReportList,
}

export default apiServices;
